let loadingHandler;
let loadingCount = 0;
const showLoading = () => {
    loadingCount++;
    clearTimeout(loadingHandler);
    loadingHandler = setTimeout(() => {
        updateLoading();
    }, 300);
};

const hideLoading = () => {
    clearTimeout(loadingHandler);
    loadingCount--;
    updateLoading();
};

const updateLoading = () => {
    if (loadingCount <= 0) {
        loadingCount = 0;
        $('#loading').hide();
    } else {
        $('#loading').css('display', 'flex');
    }
};

const LoadingHelper = {
    showLoading,
    hideLoading
};

export default LoadingHelper;
